var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"privacy_pulicy_login_page"}},[_c('PrivacyPolicy'),_vm._v(" "),_c('my-router-link',{staticClass:"back",attrs:{"id":"privacy_policy_back_button_link","name":"login","no-param":""}},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t('page.back'))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }